module.exports = __webpack_public_path__ + "assets/53e2fb3b82eafad81897aab9ab79edff.js";